import axios from 'axios'
import { isLoggedIn } from '../auth/Auth'
import { AuthBaseURL, BaseURLAdmin, getTokenFromURL, OrgBaseURL } from '../utils'
import { EntityFormData } from '../actions/Types'

const api = axios.create({
  baseURL: BaseURLAdmin,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    Authorization: `Bearer ${isLoggedIn()}`,
  },
})

export const addAuthToken = () => {
  api.defaults.headers['authorization'] = `Bearer ${isLoggedIn()}`
}

export const GET = async (url: string, params = {}) => {
  const response = await api.get(url, { params })
  return response
}

export const POST = async (url: string, data: object) => {
  const response = await api.post(url, data)
  return response
}

export const PUT = async (url: string, data: object) => {
  const response = await api.put(url, data)
  return response
}

export const DELETE = async (url: string, data?: object) => {
  const response = await api.delete(url, { data })
  return response
}

export const PATCH = async (url: string, data: object) => {
  const response = await api.patch(url, data)
  return response
}

const apiOauth = axios.create({
  baseURL: AuthBaseURL,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Acess-Control-Allow-Origin': '*',
  },
})

const apiAuth = axios.create({
  baseURL: AuthBaseURL,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    Authorization: `Bearer ${isLoggedIn()}`,
  },
})

export const apiOrg = axios.create({
  baseURL: OrgBaseURL,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    Authorization: `Bearer ${isLoggedIn()}`,
  },
})

export const postEntities = async(payload : EntityFormData)=>{
  const response = await apiOrg.post(`api/create-root-entity-admin`,payload)
  return response
}

export const getAllEntity = async()=>{
  const response = await apiOrg.get("api/entity?size=1000")
  return response
}

export const getProcessType = async()=>{
  const response = await apiOrg.get("api/processtype")
  return response
}
export const getTimeZone = async()=>{
  const response = await apiOrg.get("api/timezone")
  return response
}
export const getCountries = async()=>{
  const response = await apiOrg.get("api/countries")
  return response
}
export const getCurrencies = async()=>{
  const response = await apiOrg.get("api/currencies")
  return response
}

export const getSectorTypes = async()=>{
  const response = await apiOrg.get("api/sector-types")
  return response
}

export const OAuthPOST = async (url: string, data: any) => {
  const response = await apiOauth.post(url, new URLSearchParams(data.userData).toString(), {
    auth: {
      username: data.clientKeys.oauthClientId,
      password: data.clientKeys.clientSecret,
    },
  })
  return response
}

export const OAuthPOSTClient = async (url: string, data: any) => {
  const response = await apiAuth.post(url, data)
  return response
}


export const OAuthLogout = async (url: string) => {
  const token = isLoggedIn()
  const response = await apiOauth.post(url, null, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

export const OAuthGET = async (url: string, params?: object) => {
  apiOauth.defaults.headers['authorization'] = `Bearer ${isLoggedIn()}`
  const response = await apiOauth.get(url, { params })
  return response
}

const OAuthPUT = async (url: string, data: object, token: any) => {
  const response = await apiAuth.put(url, data, token)
  return response
}

const apiUploadImage = axios.create({
  baseURL: BaseURLAdmin,
  headers: {
    'Content-Type': 'multipart/form-data',
    'Acess-Control-Allow-Origin': '*',
    Authorization: `Bearer ${isLoggedIn()}`,
  },
})

export const UploadImagePOST = async (url: string, data: any) => {
  const formData = new FormData()
  formData.append('file', data.file)
  const response = await apiUploadImage.post(url, formData)
  return response
}

export const OAuthPassword = async (url: string, data?: object) => {
  const response = await apiAuth.post(url, data)
  return response
}

export const OAuthChangePassword = async (url: string, data: object) => {
  const token = getTokenFromURL()
  const response = await OAuthPUT(url, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}
export const OAuthResetPassword = async (url: string, data?: object) => {
  const response = await apiAuth.post(url, data)
  return response
}
